import { nullUndefined } from '@acri-tools/react-tools/utils/global';
import classNames from 'classnames';
import React,{ Component } from 'react';

import './InputList.css';

interface Props{
    type: 'text'|'select'|'number'
    label: string|React.ReactNode
    values: Array<any>
    onChange: (values:Array<any>) => void
    placeholder?: string
}
interface State{
    value: string
}


export default class InputList extends Component<Props,State>{
    constructor(props:Props){
        super(props);
        this.state={
            value: ''
        }
    }

    render(){
        return (
            <div className="input-list">
                
                <div className="input-list-add">
                    <div className="form-field">
                        <label>{this.props.label}</label>
                        { this.get_input() }
                    </div>
                    <div 
                        className={classNames({
                            "input-list-operation add": true,
                            "disabled": this.state.value === ''
                        })}
                        onClick={this.add_value}
                    >
                        <i className="fas fa-plus"/> ADD
                    </div>
                </div>
                {
                    this.props.values.length > 0 &&
                    <div className="input-list-values">
                        {
                            this.props.values.map((_, index: number)=>(
                                <div className="input-list-value">
                                    <div className="form-field">
                                        { this.get_input(index) }
                                    </div>
                                    <div 
                                        className="input-list-operation delete"
                                        onClick={()=>{ this.remove_value(index) }}
                                    >
                                        <i className="fas fa-times"/> REMOVE
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                }
            </div>
        );
    }

    keypress_handler = (e:any) =>{
        if(e?.keyCode === 13){
            this.add_value()
        }
    }

    add_value = () =>{
        let { values } = this.props;
        values.push(this.state.value);
        this.props.onChange(values);
        this.setState({ value: '' });
    }
    remove_value = (index:number) =>{
        let { values } = this.props;
        values.splice(index, 1);
        this.props.onChange(values);
        this.forceUpdate();
    }

    get_input = (index?:number) =>{
        switch(this.props.type){
            case 'text':
            case 'number':
                return ( <input 
                    placeholder={this.props.placeholder}
                    type={this.props.type} value={index !== undefined ? this.props.values[index] : this.state.value}
                    onChange={(e)=>{
                        if(index !== undefined){
                            this.props.values[index] = e.target.value;
                            this.forceUpdate();
                        }
                        else{
                            this.setState({ value: e.target.value })
                        }
                    }}
                    onKeyDown={index !== undefined ? undefined : this.keypress_handler}
                /> )
            default: return null
        }
    }

};